module.exports = __webpack_public_path__ + "media/tip_tier_4-a674c844f36be3de8591e44d3a599a17.mp3";